export default "__VITE_ASSET__CjqnLbdW__"